export interface NavigationBarProps {
  onPrev: () => void;
  onNext: () => void;
  canPrev: boolean;
  canNext: boolean;
  isLast?: boolean;
  onSubmit?: () => void;
  showSubmit?: boolean;
  primaryLabel?: string;
  submitLabel?: string;
}

export function NavigationBar({
  onPrev,
  onNext,
  canPrev,
  canNext,
  isLast,
  onSubmit,
  showSubmit,
  primaryLabel,
  submitLabel = '交卷',
}: NavigationBarProps) {
  return (
    <footer className="sticky bottom-0 z-20 flex min-h-16 flex-shrink-0 flex-wrap items-center justify-center gap-3 border-t border-slate-200 bg-white/95 px-4 py-3 shadow-[0_-12px_30px_rgba(15,23,42,0.06)] backdrop-blur sm:px-6">
      <button
        type="button"
        onClick={onPrev}
        disabled={!canPrev}
        className="h-11 min-w-[120px] rounded-md border border-slate-300 bg-white px-6 font-medium text-slate-700 hover:bg-slate-50 disabled:cursor-not-allowed disabled:opacity-40 focus:outline-none focus:ring-2 focus:ring-slate-400 focus:ring-offset-2"
      >
        上一题
      </button>
      <button
        type="button"
        onClick={onNext}
        disabled={!canNext}
        className="h-11 min-w-[120px] rounded-md bg-slate-950 px-6 font-medium text-white hover:bg-slate-800 disabled:cursor-not-allowed disabled:opacity-40 focus:outline-none focus:ring-2 focus:ring-slate-400 focus:ring-offset-2"
      >
        {primaryLabel ?? (isLast ? '完成' : '下一题')}
      </button>
      {showSubmit && onSubmit && (
        <button
          type="button"
          onClick={onSubmit}
          className="h-11 min-w-[100px] rounded-md border border-slate-300 bg-white px-6 font-medium text-slate-700 hover:bg-slate-50 focus:outline-none focus:ring-2 focus:ring-slate-400 focus:ring-offset-2"
        >
          {submitLabel}
        </button>
      )}
    </footer>
  );
}
